import { __config_dashboard } from '../../../redux/reducers';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { State, getDashboardOptions } from '../../../redux/reducers';
import { Change } from '../../../redux/actions/dashboard/actions-options';
import { Subject, Subscription, asyncScheduler } from 'rxjs';
import { CsvService } from '../../../redux/services/dashboard/csv.service';
import { valueOptions } from '../../../redux/models/dashboard/option-values';
import { PdfService } from '../../../redux/services/dashboard/pdf.service';
import { catchError, filter, map, take, subscribeOn } from 'rxjs/operators';
import { HeaderAlertService, customerConfig } from '@uxdf/direct-shared-lib';
import { isOn } from 'feature-toggle-service';
@Component({
  standalone: false,
  selector: 'app-dashboard-footer',
  templateUrl: './dashboard-footer.component.html',
  styleUrls: ['./dashboard-footer.component.scss']
})
export class DashboardFooterComponent implements OnInit, OnDestroy {
  @Input() currency = '';
  @Input() hasData = false;
  radioSubject: Subject<string>;
  filterBy = 'value';
  inputs = [];
  renderingFile = false;
  multiLine = false;
  featureToggle = isOn('dashboardDownloadCsv');
  isSalesView = false;
  private readonly subscriptions: Subscription;
  private csvData: string[][];
  private csvFileName: string;
  private segmentsEnabled = false;

  constructor(
    private readonly store: Store<State>,
    private readonly csv: CsvService,
    private readonly pdf: PdfService,
    private readonly alertService: HeaderAlertService
  ) {
    this.subscriptions = new Subscription();
    this.radioSubject = new Subject<string>();
  }

  ngOnInit() {
    this.store
      .pipe(
        select(__config_dashboard),
        filter(config => !config.isLoading),
        map(configState => configState.config.booking_types.some((bt: string) => bt === 'SEGMENT_COUNT')),
        take(1)
      )
      .subscribe(v => (this.segmentsEnabled = v));

    this.subscriptions.add(
      this.store.pipe(select(getDashboardOptions), subscribeOn(asyncScheduler)).subscribe(optionsState => {
        this.inputs = [...valueOptions];
        if (!this.segmentsEnabled || optionsState.filters.turnover === 'TOMA') {
          this.inputs = this.inputs.filter(vo => vo.value !== 'segment');
        }
        if (optionsState.filters.turnover !== 'TOMA') {
          this.inputs = this.inputs.filter(vo => vo.value !== 'passengers');
        }
        this.filterBy = optionsState.filterBy;
        if (!this.inputs.some(ov => ov.value === this.filterBy)) {
          this.filterBy = this.inputs[0].value;
          this.store.dispatch(new Change({ options: { filterBy: this.filterBy } }));
        }
        this.multiLine = this.inputs.length > 2;
      })
    );

    this.subscriptions.add(
      this.radioSubject.subscribe(value => {
        this.filterBy = value;
        this.store.dispatch(new Change({ options: { filterBy: value } }));
      })
    );

    this.subscriptions.add(
      this.csv.getResult().subscribe(csvData => {
        // avoid double clicks and too short loading animation on powerful devices
        setTimeout(() => (this.renderingFile = false), 500);
        this.csvData = csvData;
      })
    );
    this.csvFileName = this.csv.getFileName();

    const pdfObservable = this.pdf.getResult().pipe(
      catchError(() => {
        this.alertService.add({
          type: 'error',
          content: 'dashboardRequestError',
          translate: true
        });
        this.renderingFile = false;
        return pdfObservable;
      })
    );
    this.subscriptions.add(
      pdfObservable.subscribe(pdf => {
        setTimeout(() => (this.renderingFile = false), 500);
        pdf.save(this.pdf.getFileName());
      })
    );
    this.subscriptions.add(
      this.store.pipe(select(customerConfig)).subscribe(res => {
        this.isSalesView = res.customerConfig.is_salesView;
      })
    );
  }

  renderFile(type: string) {
    if (!this.renderingFile) {
      this.renderingFile = true;
      // start rendering after the loader is shown
      setTimeout(() => this[type].update(), 0);
    }
  }

  downloadCsvFile() {
    this.csv
      .getResult()
      .subscribe(csvData => {
        setTimeout(() => (this.renderingFile = false), 500);

        this.csvData = csvData;
        this.csvFileName = this.csv.getFileName();

        this.csv.downloadFile(this.csvData, this.csvFileName);
      })
      .unsubscribe();
  }

  print() {
    window.print();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
